import { useParams, Link } from 'react-router';
import { cn } from '~/common/utils/styleUtil';
import { useTranslation } from 'react-i18next';
import { LucideShoppingCart, LucideTruck, LucideHouse } from 'lucide-react';
import { PgArea, TgArea } from '~/common/types/area';
import { getLinkRel } from '~/common/utils/urlUtil';
import { fallbackLng } from '~/i18nConfig';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

export function AreaSwitcher() {
  const { area, lang: langParam } = useParams();
  const { t } = useTranslation();
  const lang = langParam ?? fallbackLng;

  return (
    <div className={'flex gap-4'}>
      <TrackNavigationClick label={t('Belieferung')}>
        <Link
          className={cn(
            'flex items-center gap-1 cursor text-secondary hover:text-primary',
            area === TgArea && 'text-primary-dark'
          )}
          to={`/${lang}/${TgArea}`}
          data-testid={'tg-link'}
        >
          <LucideTruck size={18} />
          <div>{t('Belieferung')}</div>
        </Link>
      </TrackNavigationClick>
      <TrackNavigationClick label={t('Abholung')}>
        <Link
          className={cn(
            'flex items-center gap-1 cursor text-secondary hover:text-primary',
            area === PgArea && 'text-primary-dark'
          )}
          to={`/${lang}/${PgArea}`}
          data-testid={'pg-link'}
        >
          <LucideShoppingCart size={14} />
          <div>{t('Abholung')}</div>
        </Link>
      </TrackNavigationClick>
      <TrackNavigationClick label={t('Unternehmen')}>
        <a
          href={'https://www.transgourmet.ch'}
          target={'_blank'}
          rel={getLinkRel('https://www.transgourmet.ch')}
          className={'flex items-center gap-1 cursor text-secondary hover:text-primary'}
          data-testid={'homepage-link'}
        >
          <LucideHouse size={14} />
          <div>{t('Unternehmen')}</div>
        </a>
      </TrackNavigationClick>
    </div>
  );
}
